module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded2"
  }, [_vm._v("The author wishes to thank the Texas Institute of Letters")]), _c('p', {
    staticClass: "ded"
  }, [_vm._v("and the University of Texas at Austin for the Dobie-Paisano Fellowship,")]), _c('p', {
    staticClass: "ded"
  }, [_vm._v("and the Copernicus Society of America")]), _c('p', {
    staticClass: "ded"
  }, [_vm._v("for the James Michener Award.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2057dfcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Brownsville_dedi-1.vue
// module id = 72
// module chunks = 0